import { ReferenceInput, AutocompleteInput } from 'react-admin';

const ProviderFilter = (props) => (
    <ReferenceInput reference="admin/providers" source="provider_id" label="Provider" {...props}>
        <AutocompleteInput
            label="Provider"
            source="provider_id"
            name="provider_id"
            //optionText="name"
        />
    </ReferenceInput>
);
export default ProviderFilter